import { isRlink } from "./constants";

const DEFAULT_KEY = isRlink ? `-pl` : '';

export const SOCKET_EVENTS = {
    CON: `con${DEFAULT_KEY}`,
    RCON: `rcon${DEFAULT_KEY}`,
    ALL: `all${DEFAULT_KEY}`,
    ADD: `add${DEFAULT_KEY}`,
    UPD: `upd${DEFAULT_KEY}`,
    REM: `rem${DEFAULT_KEY}`,
    ROOM_UNMUTED_LIST: `room-unmuted-list${DEFAULT_KEY}`,
    MSG: `msg${DEFAULT_KEY}`,
    MSG_DELETE: `msg-delete${DEFAULT_KEY}`,
    MSG_FEATURED: `msg-featured${DEFAULT_KEY}`,
    MSG_UNFEATURED: `msg-unfeatured${DEFAULT_KEY}`,
    ROOM_SETTINGS: `room-settings${DEFAULT_KEY}`,
    SHOW: `show${DEFAULT_KEY}`,
    HIDE: `hide${DEFAULT_KEY}`,
    MEDIA_SET: `media-set${DEFAULT_KEY}`,
    WIDGET_ACTIVE: `widget-active${DEFAULT_KEY}`,
    LEM_REQUEST_CAPTION: `lem-request-caption${DEFAULT_KEY}`,
    CAPTION_MSG: `caption-msg${DEFAULT_KEY}`,
    LEM_CAPTION_LANGUAGE: `lem-caption-language${DEFAULT_KEY}`,
    TIMER_SHOW: `timer-show${DEFAULT_KEY}`,
    TIMER_HIDE: `timer-hide${DEFAULT_KEY}`,
    TIMER_WIDGET_ACTIVE: `timer-widget-active${DEFAULT_KEY}`,
    EVENT_TRANSLATION_UPD: `event-translation-upd${DEFAULT_KEY}`,
    LEAVE_TRANSCRIBER: `leave-transcriber${DEFAULT_KEY}`,
    WIDGET_FOLDER_ITEM_SYNC_CONTROL: `widget-folder-item-sync-control${DEFAULT_KEY}`
}